import {Stack} from "@chakra-ui/react";
import Loading from "../../../components/Loading";
import TotalWithChart from "../parts/TotalWithChart";
import DataChart from "../parts/DataChart";
import UsagePart from "../parts/UsagePart";

const Sales = ({data,isLoadingTypeData, companyColors, usage}) => {

    if (isLoadingTypeData) return <Loading/>

    return (
        data &&
        <Stack spacing={10}>
            <TotalWithChart
                companyColors={companyColors}
                data={data['property']}
                gridName={'Energy Consultant'}
                gridNameCounts={'Square Footage'}
                chartTitle={'Total Active Project Square Footage'}
                header={'Active Project Square Footage'}
                chartSide={'right'}/>
            <DataChart
                chartLeftSide={'Dollars'}
                header={'Proposal Amount Accepted'}
                data={data['proposal']}/>
            <TotalWithChart
                companyColors={companyColors}
                data={data['active']}
                gridName={'User'}
                gridNameCounts={'Projects'}
                chartTitle={'Active Projects'}
                header={'Active Projects'}
                chartSide={'left'}/>
            <DataChart
                bottomText={'Users'}
                chartLeftSide={'Luminaire System Amount'}
                header={'Luminaire System Amount Sold'}
                data={data['led_sold']}/>
            <UsagePart
                companyColors={companyColors}
                usage={usage}/>
        </Stack>
    )
}

export default Sales